import React from "react";

import LongText from "./LongText";
import MultipleChoice from "./MultipleChoice";
import NotExist from "./NotExist";
import PhotoUpload from "./PhotoUpload";
import ShortText from "./ShortText";

interface Props {
  question: any | null | undefined;
  response: any;
}

const Question: React.FC<Props> = ({ question, response }) => {
  if (question == null) {
    return <NotExist />;
  }

  switch (question.type) {
    case "multipleChoice":
      return <MultipleChoice question={question} response={response} />;
    case "photoUpload":
      return <PhotoUpload question={question} response={response} />;
    case "shortText":
      return <ShortText question={question} response={response} />;
    case "longText":
      return <LongText question={question} response={response} />;
    default:
      return null;
  }
};

export default Question;
